const MAX_JOB_AD_DATE_RANGE_DAYS = 180;

type JobAdDateValue = Date | string | null | undefined;

const normalizeDate = (value: JobAdDateValue) => {
  if (!value) {
    return null;
  }

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return null;
  }

  parsedDate.setHours(0, 0, 0, 0);
  return parsedDate;
};

export const getToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

export const getStartDateValidationError = (startDate: JobAdDateValue) => {
  const normalizedStartDate = normalizeDate(startDate);
  if (!normalizedStartDate) {
    return null;
  }

  if (normalizedStartDate < getToday()) {
    return "jobAds:validation:startDatePast";
  }

  return null;
};

export const getEndDateValidationError = (
  endDate: JobAdDateValue,
  startDate: JobAdDateValue,
) => {
  const normalizedEndDate = normalizeDate(endDate);
  if (!normalizedEndDate) {
    return null;
  }

  const today = getToday();
  if (normalizedEndDate < today) {
    return "jobAds:validation:endDatePast";
  }

  const effectiveStartDate = normalizeDate(startDate) || today;
  if (normalizedEndDate < effectiveStartDate) {
    return "jobAds:validation:endDateBeforeStartDate";
  }

  const diffInDays =
    (normalizedEndDate.getTime() - effectiveStartDate.getTime()) /
    (1000 * 60 * 60 * 24);
  if (diffInDays > MAX_JOB_AD_DATE_RANGE_DAYS) {
    return "jobAds:validation:dateRangeTooLong";
  }

  return null;
};

export const isJobAdDateRangeValid = (
  startDate: JobAdDateValue,
  endDate: JobAdDateValue,
) =>
  !getStartDateValidationError(startDate) &&
  !getEndDateValidationError(endDate, startDate);
